import { render } from "./BlueDress.vue?vue&type=template&id=411bfde6"
import script from "./BlueDress.vue?vue&type=script&lang=js"
export * from "./BlueDress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__